import {
  Activity,
  Airplay,
  BarChart2,
  Bell,
  Book,
  Briefcase,
  Calendar,
  CheckCircle,
  Clipboard,
  Database,
  FileText,
  Grid,
  HelpCircle,
  Home,
  Key,
  Layers,
  MessageCircle,
  Phone,
  Settings,
  Shield,
  Upload,
  User,
  UserCheck,
  Users,
  XCircle,
} from "react-feather";

/** Canonical sidebar icons keyed by permission slug (API + menuConstant). */
export const MENU_SLUG_ICONS = {
  dashboard: Home,
  dashboard1: Home,
  dashboard2: Home,
  dashboard3: Home,
  access_control: Key,
  user_management: User,
  property_management: Airplay,
  role_management: Shield,
  module_management: Grid,
  master_management: Database,
  channel_management: Users,
  visitor_management: UserCheck,
  closing_manager: Briefcase,
  sourcing_manager: Briefcase,
  appointment_management: Calendar,
  "appointment_ site_visit": Calendar,
  appointment_with_cp: Calendar,
  new_upload: Upload,
  verify_lead: CheckCircle,
  followup_management: Phone,
  scheduled_activity: Activity,
  support_forum: MessageCircle,
  support: HelpCircle,
  configuration_management: Settings,
  booking_management: Book,
  cancel_booking: XCircle,
  registration_management: Clipboard,
  report: BarChart2,
  dispositionReport: FileText,
  getChannelPartnerAppointments: Users,
  project_details_report: Layers,
  report_management: BarChart2,
  user_announcement: Bell,
  mdoc_audit_log: FileText,
};

export const getMenuIconBySlug = (slug) =>
  slug && MENU_SLUG_ICONS[slug] ? MENU_SLUG_ICONS[slug] : null;
